import React from 'react';
import ReactSVG from "react-svg";
import {useDialogueGuideSettings} from "../hooks/useDialogueGuideSettings.mjs";
import classnames from "classnames";

const MemberIcons = ({ className }) => {
    const {isFdicMember, isEhlMember} = useDialogueGuideSettings();
    const classes = classnames('memberIcons', className);

    return (isFdicMember || isEhlMember) ? <div className={classes}>
        {isEhlMember ? <ReactSVG src='/classpath/assets/images/ehl-logo.svg' className='ehl-icon'/> : null}
        {isFdicMember ? <ReactSVG src='/classpath/assets/images/fdic-logo.svg' className='fdic-icon'/> : null}
    </div> : null};

export default MemberIcons;
